import React from 'react'

import CardItem from './Component/CardItem';
import './Workscard.css'
import Footer from './Component/footer'
import { Element } from 'react-scroll'

const Branding = () => {
  
    return (



      <div className='cards'>
        
        <div className='cards__container'>
          <div className='cards__wrapperr'>
          
           
  
           
  
             <ul className='cards__items'  >
             
              <CardItem id='testpad'
                src='images/wowbii.png'
                text='Wowbii socail media content creation'
                label='Social Media Design'
                path='/Wowbii'
              />
              <CardItem id='testpad'
            src='images/wacha1.png'
            text='VOD platform full brand identity development'
            label='Brand Identity Design'
            path='/Wacha' 
          />
          <CardItem 
              src='images/soe.png'
              text='School of Experience full brand identity development'
              label='Brand Identity Design'
              path='/Soe'
            />
              
  
            
        
            </ul>
            
            <ul className='cards__items'>
            <CardItem
              src='images/BOE.jpg'
              text='Brand Experience Optimizer©'
              label='B.O.E'
              path='/products'
          />  
  
            {/*
            <CardItem id='testpad'
            src='images/roadbuddies.jpg'
            text='Roadbuddies mobile signin page '
            label='UI/UX Design'
            path='/Roadbuddies'
        /> */}
           
          <CardItem
          src='images/ninext.jpg'
          text='Ninext Social Media content creation'
          label='Social Media Design'
          path='/Brainshare'
           />
           
          </ul>
  
          
  
  
        
          <ul className='cards__items'>
          
          <CardItem 
              src='images/img-3.jpg'
              text='A touch of magic'
              label='Photomanipulation'
              path='/Photoma'
            />
            
          </ul>
          
          </div>
       
        </div>
        <Element  id='contact' name='footer'> 
      <Footer />
      </Element>
      </div>
    
    );
  }

export default Branding
